export const REGISTER_BY_EMAIL = 'REGISTER_BY_EMAIL';
export const SET_REGISTER_FORM = 'SET_REGISTER_FORM';
export const SET_CONSOLIDATED_FLOW = 'SET_CONSOLIDATED_FLOW [REGISTER]';
